import { useEffect } from 'react';
import { useLanguage} from "../hooks/useLanguage";

//function to update the Right-to-Left (RTL) Support for Arabic and others languages if needed

function HtmlAttributesUpdater() {
    const { selectedLanguage } = useLanguage()

    useEffect(() => {
        document.documentElement.lang = selectedLanguage;
        // Update dir attribute based on language
        const isRTL = ['ar', 'ur', 'fa'].includes(selectedLanguage); //add more languages for rtl orientation
        document.body.dir = isRTL ? 'rtl' : 'ltr';
    }, [selectedLanguage]);

    return null;
}

export default HtmlAttributesUpdater;